<script setup lang="ts">
const { t } = useI18n()

const title = t('privacyPolicy.seo.title')
const description = t('privacyPolicy.seo.description')

useSeoMeta({
    title,
    description,
    robots: 'noindex,nofollow',
})
</script>

<template>
    <section>
        <div class="pt-[60px] pb-[40px] sm:pt-24 sm:pb-12">
            <UContainer>
                <div class="flex flex-col gap-4.5 items-center lg:max-w-[800px] mx-auto">
                    <h1 class="uppercase text-[#0A5A75] text-[30px] leading-[38px] sm:text-[46px] sm:leading-[48px] text-center">{{ t('privacyPolicy.title') }}</h1>
                </div>
            </UContainer>
        </div>
        <div class="sm:pt-24 pb-60 sm:pb-70 relative overflow-x-clip">
            <UContainer>
                <div class="flex flex-col gap-20 lg:max-w-[800px] mx-auto">
                    <div class="text-[#012C3B]">
                        <p class="font-extrabold text-[22px] leading-[36px]">{{ t('privacyPolicy.name')}}</p>
                        <p>{{ t('privacyPolicy.date') }}</p>
                    </div>
                    <div class="flex flex-col gap-12">
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('privacyPolicy.section1.title')}}</h2>
                            <p>{{ t('privacyPolicy.section1.text') }}</p>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('privacyPolicy.section2.title')}}</h2>
                            <p v-html="t('privacyPolicy.section2.text')"></p>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('privacyPolicy.section3.title')}}</h2>
                            <p class="mb-4">{{ t('privacyPolicy.section3.text') }}</p>
                            <ul class="list-disc">
                                <li class="ml-6 mb-2" v-html="t('privacyPolicy.section3.list.item1')"></li>
                                <li class="ml-6 mb-2" v-html="t('privacyPolicy.section3.list.item2')"></li>
                                <li class="ml-6 mb-2" v-html="t('privacyPolicy.section3.list.item3')"></li>
                                <li class="ml-6 mb-2" v-html="t('privacyPolicy.section3.list.item4')"></li>
                                <li class="ml-6 mb-2" v-html="t('privacyPolicy.section3.list.item5')"></li>
                                <li class="ml-6" v-html="t('privacyPolicy.section3.list.item6')"></li>
                            </ul>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('privacyPolicy.section4.title')}}</h2>
                            <p class="mb-4">{{ t('privacyPolicy.section4.text') }}</p>
                            <ul class="list-disc">
                                <li class="ml-6 mb-2">{{ t('privacyPolicy.section4.list.item1') }}</li>
                                <li class="ml-6 mb-2">{{ t('privacyPolicy.section4.list.item2') }}</li>
                                <li class="ml-6 mb-2">{{ t('privacyPolicy.section4.list.item3') }}</li>
                                <li class="ml-6 mb-2">{{ t('privacyPolicy.section4.list.item4') }}</li>
                                <li class="ml-6 mb-2">{{ t('privacyPolicy.section4.list.item5') }}</li>
                                <li class="ml-6">{{ t('privacyPolicy.section4.list.item6') }}</li>
                            </ul>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('privacyPolicy.section5.title')}}</h2>
                            <p class="mb-4">{{ t('privacyPolicy.section5.text') }}</p>
                            <ul class="list-disc">
                                <li class="ml-6 mb-2" v-html="t('privacyPolicy.section5.list.item1')"></li>
                                <li class="ml-6 mb-2" v-html="t('privacyPolicy.section5.list.item2')"></li>
                                <li class="ml-6 mb-2" v-html="t('privacyPolicy.section5.list.item3')"></li>
                                <li class="ml-6" v-html="t('privacyPolicy.section5.list.item4')"></li>
                            </ul>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('privacyPolicy.section6.title')}}</h2>
                            <p class="mb-4">{{ t('privacyPolicy.section6.text1') }}</p>
                            <ul class="list-disc">
                                <li class="ml-6 mb-2">{{ t('privacyPolicy.section6.list.item1') }}</li>
                                <li class="ml-6 mb-2">{{ t('privacyPolicy.section6.list.item2') }}</li>
                                <li class="ml-6 mb-4">{{ t('privacyPolicy.section6.list.item3') }}</li>
                            </ul>
                            <p>{{ t('privacyPolicy.section6.text2') }}</p>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('privacyPolicy.section7.title')}}</h2>
                            <p class="mb-4">{{ t('privacyPolicy.section7.text1') }}</p>
                            <ul class="list-disc">
                                <li class="ml-6 mb-2" v-html="t('privacyPolicy.section7.list.item1')"></li>
                                <li class="ml-6 mb-2" v-html="t('privacyPolicy.section7.list.item2')"></li>
                                <li class="ml-6 mb-2" v-html="t('privacyPolicy.section7.list.item3')"></li>
                                <li class="ml-6 mb-2" v-html="t('privacyPolicy.section7.list.item4')"></li>
                                <li class="ml-6 mb-2" v-html="t('privacyPolicy.section7.list.item5')"></li>
                                <li class="ml-6 mb-4" v-html="t('privacyPolicy.section7.list.item6')"></li>
                            </ul>
                            <p class="mb-4" v-html="t('privacyPolicy.section7.text2')"></p>
                            <p v-html="t('privacyPolicy.section7.text3')"></p>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('privacyPolicy.section8.title')}}</h2>
                            <p class="mb-4">{{ t('privacyPolicy.section8.text1') }}</p>
                            <ul class="list-disc">
                                <li class="ml-6 mb-2">{{ t('privacyPolicy.section8.list.item1') }}</li>
                                <li class="ml-6 mb-2">{{ t('privacyPolicy.section8.list.item2') }}</li>
                                <li class="ml-6 mb-4">{{ t('privacyPolicy.section8.list.item3') }}</li>
                            </ul>
                            <p>{{ t('privacyPolicy.section8.text2') }}</p>
                        </div>
                        <div class="text-[#012C3B]">
                            <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('privacyPolicy.section9.title')}}</h2>
                            <p>{{ t('privacyPolicy.section9.text') }}</p>
                        </div>
                    </div>
                    <div class="flex flex-col gap-12">
                        <h2 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4 uppercase">{{ t('privacyPolicy.cookieTitle')}}</h2>
                        <div class="text-[#012C3B]">
                            <h3 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('privacyPolicy.section10.title')}}</h3>
                            <p>{{ t('privacyPolicy.section10.text') }}</p>
                        </div>
                        <div class="text-[#012C3B]">
                            <h3 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('privacyPolicy.section11.title')}}</h3>
                            <ul class="list-disc">
                                <li class="ml-6 mb-2" v-html="t('privacyPolicy.section11.list.item1')"></li>
                                <li class="ml-6 mb-2" v-html="t('privacyPolicy.section11.list.item2')"></li>
                                <li class="ml-6" v-html="t('privacyPolicy.section11.list.item3')"></li>
                            </ul>
                        </div>
                        <div class="text-[#012C3B]">
                            <h3 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('privacyPolicy.section12.title')}}</h3>
                            <p>{{ t('privacyPolicy.section12.text') }}</p>
                        </div>
                        <div class="text-[#012C3B]">
                            <h3 class="font-extrabold text-[30px] leading-[38px] text-[#0A5A75] mb-4">{{ t('privacyPolicy.section13.title')}}</h3>
                            <p v-html="t('privacyPolicy.section13.text')"></p>
                        </div>
                    </div>
                </div>
            </UContainer>
        </div>
    </section>
</template>

<style scoped>

</style>
